import { images } from '../constants';

const team = [ 
    {
        id: 1,
        image: images.team1,
        name: 'John Smith',
        title: 'Sales Head',
        biography: "John Smith is a dynamic Sales Head with years of experience in automotive sales and customer relations. His leadership skills and strategic mindset drive the team to achieve exceptional results. Passionate about delivering top-notch service, John ensures every client finds the perfect vehicle that suits their needs and budget.",
        contacts: {
            phone: '111-222-3344',
            email: 'john.smith@example.com',
            website: 'www.johnsmith.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Key Achievements in Sales Management:',
            points: [ 
                'Led a high-performing sales team',
                'Implemented innovative sales strategies',
                'Achieved record-breaking sales targets',
                'Built long-term client relationships',
                'Developed strong partnerships with dealerships',
            ],
        },
        skills: [
            {id: 1, title: 'Sales Strategy', progress: 95},
            {id: 2, title: 'Customer Relationship', progress: 90},
            {id: 3, title: 'Team Leadership', progress: 85},
        ],
    },
    {
        id: 2,
        image: images.team2,
        name: 'Sarah Johnson',
        title: 'Service Advisor',
        biography: "Sarah Johnson is an expert Service Advisor known for her in-depth knowledge of automotive maintenance and repairs. She provides top-notch guidance to customers, ensuring they receive the best service tailored to their vehicle’s needs. Her dedication to customer satisfaction sets her apart in the industry.",
        contacts: {
            phone: '222-333-4455',
            email: 'sarah.johnson@example.com',
            website: 'www.sarahjohnson.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Key Areas of Expertise in Service Advisory:',
            points: [ 
                'Vehicle diagnostics and maintenance',
                'Customer service and support',
                'Efficient service scheduling',
                'Technical knowledge of vehicle systems',
                'Enhancing customer satisfaction',
            ],
        },
        skills: [
            {id: 1, title: 'Automotive Knowledge', progress: 95},
            {id: 2, title: 'Customer Service', progress: 90},
            {id: 3, title: 'Problem-Solving', progress: 85},
        ],
    },
    {
        id: 3,
        image: images.team3,
        name: 'Michael Brown',
        title: 'Sales Consultant',
        biography: "Michael Brown is a seasoned Sales Consultant specializing in helping clients find their dream vehicles. With a keen eye for customer needs and market trends, he excels in providing personalized service and expert advice.",
        contacts: {
            phone: '333-444-5566',
            email: 'michael.brown@example.com',
            website: 'www.michaelbrown.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Expertise in Automotive Sales:',
            points: [ 
                'Personalized car recommendations',
                'Negotiation and deal structuring',
                'Understanding client preferences',
                'Maintaining excellent customer service',
                'Market trend analysis',
            ],
        },
        skills: [
            {id: 1, title: 'Sales Consultation', progress: 95},
            {id: 2, title: 'Negotiation', progress: 90},
            {id: 3, title: 'Client Relations', progress: 85},
        ],
    },
    {
        id: 4,
        image: images.team4,
        name: 'Emily Davis',
        title: 'Support Lead',
        biography: "Emily Davis is a dedicated Support Lead ensuring seamless customer service operations. She oversees support teams, resolves complex customer issues, and enhances service efficiency through strategic planning and innovation.",
        contacts: {
            phone: '444-555-6677',
            email: 'emily.davis@example.com',
            website: 'www.emilydavis.com',
        },
        accounts: {
            facebook: '#',
            linkedin: '#',
            twitter: '#',
            instagram: '#',
        },
        experience: {
            intro: 'Core Strengths in Customer Support:',
            points: [ 
                'Efficient team management',
                'Resolving customer inquiries promptly',
                'Enhancing support processes',
                'Training and mentoring teams',
                'Optimizing customer satisfaction',
            ],
        },
        skills: [
            {id: 1, title: 'Customer Support', progress: 95},
            {id: 2, title: 'Team Management', progress: 90},
            {id: 3, title: 'Problem Resolution', progress: 85},
        ],
    }
];

export default team;